module.exports = __webpack_public_path__ + "img/golfsurfen--dark.fc540068.svg";